var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialEquipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 40,
    height: 40,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.2 3.4l3.4 3.4v2.8h-2.8l-3.4-3.4-2 6.6 6.4 6.4 4.4-1.2 10 10 5.6-5.6-10-10 1.2-4.4-6.2-6.6-6.6 2zM25 21.6l-1.4 1.4-7-7 1.4-1.4 7 7z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialEquipment);
export default __webpack_public_path__ + "static/media/special_equipment.44b711a60794fe55023492f85a58f545.svg";
export { ForwardRef as ReactComponent };